module.exports = __webpack_public_path__ + "static/media/error.a6bf67ec.svg";